import styled from "styled-components";

export const DropdownWrapper = styled.div`
  position: absolute;
  top: 120%;
  right: 0;
  z-index: 5;
  min-width: 120px;
  background-color: var(--theme-color-secondary);
  border: 1px solid var(--border-color);
  padding: 5px 0;
  border-radius: 10px;
  overflow: hidden;
  display: ${(props) => (props.$isOpen ? 'block' : 'none')};

  &.dropdown-upward {
    top: auto;
    bottom: 120%;
  }
`;

export const DropdownList = styled.ul`
  max-width: 400px;
  list-style-type: none;
  padding: 0;
  margin: 0;
  font-size: 14px;

  & > *:not(:last-child) {
    border-bottom: 1px solid var(--table-border-color);
  }
`;

export const DropdownListItem = styled.li`
  background-color: transparent;
  color: var(--text-color-secondary);
  text-transform: capitalize;
  text-align: left;
  white-space: nowrap;
  padding: 10px 20px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all ease-in-out 0.3s;

  &:hover {
    background-color: var(--theme-color-primary);
    color: var(--theme-color-white);
  }
`;